import React, { useEffect } from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, icon, content }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <i className="bi bi-x-lg"></i>
        </button>

        <div className="modal-content-wrapper">
          <div className="modal-header">
            <div className="modal-icon">
              <i className={icon}></i>
            </div>
            <h2 className="modal-title">{title}</h2>
          </div>

          <div className="modal-body">
            {content}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
